// Yazdırılabilir alan içinde açılır/kapanır grid. pointer-events yok (tıklamayı engellemez).
import { PX_PER_MM } from './geometry';

export function GridOverlay({ gridMm, zoom, widthPx, heightPx }) {
  const step = Math.max(1, gridMm) * PX_PER_MM * zoom;
  return (
    <div
      style={{
        position: 'absolute', left: 0, top: 0, width: widthPx, height: heightPx,
        pointerEvents: 'none', zIndex: 0,
        backgroundImage: `repeating-linear-gradient(to right, var(--designer-grid-line) 0, var(--designer-grid-line) 1px, transparent 1px, transparent ${step}px),
                          repeating-linear-gradient(to bottom, var(--designer-grid-line) 0, var(--designer-grid-line) 1px, transparent 1px, transparent ${step}px)`,
      }}
    />
  );
}
